export default __webpack_public_path__ + "static/media/how_it_works_3.2e5d4fdb.png";